import { useContext } from 'react';

import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import CustomImageComponent from '@/components/shared/custom/custom-image';
import ApercibidosStatusIcon from '@/components/shared/icons/apercibidos-status-icon';
import { REDUCERS } from '@/constants/reducers';
import { Context } from '@/context';
import { getCountryImage, getMasterPhotoById } from '@/helpers/images-helper';
import { getPlayerIconWhenIsNotOk } from '@/helpers/players-helper';

import EquipoAddPlayerBox from './EquipoAddPlayerBox';
import { THEME_MODE } from '@/constants/site';
import Porcentajes from '@/components/alineaciones/shared/complementos/Porcentajes';

const EquipoPlayerLineupAnaliticaMode = ({ player, onClick, customSize, textColor, banquillo = false }) => {
    const { state, dispatch } = useContext(Context);
    const id = player?.information?.id ?? 0;
    let color = banquillo && state.theme === THEME_MODE.LIGHT ? '#000' : '#fff';

    if (textColor) {
        color = textColor;
    }

    const isMobile = useMediaQuery('(max-width:576px)');
    let size = isMobile ? 70 : 80;

    if (customSize) {
        size = customSize;
    }

    const cardHeight = isMobile ? 120 : 130;

    const handleClick = (playerId) => {
        if (onClick) {
            onClick();
        } else if (playerId > 0) {
            dispatch({ type: REDUCERS.SHOW_MASTER_ACCIONES_PLAYER_ID, payload: playerId });
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: banquillo ? 'auto' : cardHeight,
                width: size,
            }}
            onClick={() => handleClick(id)}
        >
            <Box sx={{ position: 'relative', width: size, height: size }}>
                <CustomImageComponent
                    src={getMasterPhotoById(id, size * 1.5)}
                    alt="jugador"
                    width={size}
                    height={size}
                />

                {player?.generalStatus?.isApercibido && (
                    <ApercibidosStatusIcon
                        iconWidth={15}
                        iconHeight={15}
                        styles={{ position: 'absolute', bottom: 0, left: '8px' }}
                    />
                )}

                <Box style={{ position: 'absolute', bottom: 0, right: '5px' }}>
                    {player?.information?.id > 0 &&
                        getPlayerIconWhenIsNotOk(
                            player?.generalStatus?.status,
                            player?.generalStatus?.statusLevel
                        )}
                </Box>

                {player?.convocatoriaSeleccion?.isConvocado && (
                    <Box style={{ position: 'absolute', top: 0, right: 0 }}>
                        <CustomImageComponent
                            src={getCountryImage(player?.convocatoriaSeleccion?.countryCode, 30)}
                            width={20}
                            height={20}
                            alt="selección"
                            style={{ borderRadius: '50%' }}
                        />
                    </Box>
                )}
            </Box>
            {player?.isAnalisis || player?.chance >= 0 || !onClick ? (
                <Porcentajes
                    porcentaje={player.chance}
                    fontSize={10}
                    width={'50px'}
                    height={'15px'}
                    comentario={player.comentario}
                    leftComentario={30}
                />
            ) : (
                <EquipoAddPlayerBox />
            )}

            <Typography
                variant="body2"
                sx={{
                    textAlign: 'center',
                    fontSize: '14px',
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: color,
                }}
            >
                {player?.information?.name ??
                    player?.name ??
                    player?.nickname ??
                    player?.information?.nickname}
            </Typography>
            {banquillo === false &&
                player?.alternatives?.map((alt, i) => {
                    return (
                        <Box
                            key={`alt-${i}`}
                            sx={{
                                fontSize: '13px',
                                whiteSpace: 'nowrap',
                                textAlign: 'center',
                                color: '#ccc',
                                borderRadius: '4px',
                                opacity: '0.9',
                                minWidth: '70px',
                                position: 'absolute',
                                bottom: `${(i + 1) * -15}px`,
                            }}
                        >
                            <Typography variant="span" style={{ marginRight: '4px' }}>
                                {alt?.information?.name}
                            </Typography>
                            {getPlayerIconWhenIsNotOk(
                                alt?.generalStatus?.status,
                                alt?.generalStatus?.statusLevel
                            )}
                        </Box>
                    );
                })}
        </Box>
    );
};

export default EquipoPlayerLineupAnaliticaMode;
